import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, withCtx as _withCtx, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7030c7d2"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "PageHeader__placeholder" }, null, -1))
const _hoisted_2 = { class: "PageHeader__container" }
const _hoisted_3 = { class: "PageHeader__left" }
const _hoisted_4 = {
  class: "PageHeader__title",
  "data-test": "title-text"
}
const _hoisted_5 = { class: "PageHeader__right" }

import { useRouter, useRoute } from 'vue-router';
// 三方组件
import { Overlay as vanOverlay } from 'vant';
import PageHeaderIcon from './PageHeaderIcon.vue';
import backIcon from './images/back.png';
import shareIcon from './images/share.png';
import BackDialog from '@/components/Dialog/BackDialog.vue';
import { useShare } from '@/hooks/useShare';
import { useLogin } from '@/hooks/uselogin';
import { usePageLeave } from '@/hooks/usePageLeave';


export default /*#__PURE__*/_defineComponent({
  props: {
  title: { type: String, require: false, default: '' },
},
  setup(__props) {

const { showBack } = usePageLeave();
const { clickLogin } = useLogin();

const router = useRouter();
const route = useRoute();
const doShare = useShare();



function onShare () {
  if (clickLogin()) {
    doShare({
      title: '快看可以领币免费看漫画啦！快来跟我组队一起薅羊毛吧>V<',
      desc: '快看APP真的有超多好看的漫画，快来一起看呀~~',
      shareImage: `${process.env.VUE_APP_SHARE_IMAGE}`,
    });
  }
}

function onBack () {
  if (route.path === '/') {
    showBack.value = true;
  } else {
    router.back();
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("header", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(PageHeaderIcon, {
          "icon-url": _unref(backIcon),
          handler: onBack,
          "data-test": "back-btn"
        }, null, 8, ["icon-url"])
      ]),
      _createElementVNode("h1", _hoisted_4, _toDisplayString(__props.title), 1),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(PageHeaderIcon, {
          "icon-url": _unref(shareIcon),
          handler: onShare,
          "data-test": "share-btn"
        }, null, 8, ["icon-url"])
      ])
    ]),
    _createVNode(_unref(vanOverlay), {
      show: _unref(showBack),
      "z-index": 1000
    }, {
      default: _withCtx(() => [
        (_openBlock(), _createBlock(_resolveDynamicComponent(BackDialog), {
          onClose: _cache[0] || (_cache[0] = ($event: any) => (showBack.value = false))
        }))
      ]),
      _: 1
    }, 8, ["show"])
  ], 64))
}
}

})